import useFeatureFlag from '../../../../Hooks/useFeatureFlag'
import ClickToCopy from '../../../../Molecules/ClickToCopy/ClickToCopy'
import styles from './BrandSkuWrapper.module.scss'

import React from 'react'

import ClassNames from 'classnames'

import Typography from 'Atoms/Typography'

const BrandSkuWrapper = ({ product, className }) => {
  const shouldShowCXPartNumberCopyButton = useFeatureFlag('CX_PartNumber_CopyButton')

  return (
    <span className={ClassNames(styles.brandWrapper, className)}>
      {product.brand ? (
        <p
          className="p p-subtle p-0_875"
          style={{
            marginRight: '0.25rem',
            display: 'inline-flex',
            flexWrap: 'wrap',
          }}
        >
          {product.brand} |
        </p>
      ) : (
        false
      )}
      <Typography
        size={0.875}
        tone={'subtle'}
        href={product.productPageUrl}
        inline
        className={styles.skuText}
        onClick={(e) => e.preventDefault()}
      >
        {`#${product.skuBaseNumber}`}
        {shouldShowCXPartNumberCopyButton && (
          <ClickToCopy className={styles.title_spacer} textToCopy={product.skuBaseNumber ?? ''} size={0.875} />
        )}
      </Typography>
    </span>
  )
}

export default BrandSkuWrapper
